/**
 * @title search.js: Sub-module of Browse feature
 * @description This module encapsulates all of the
 * functionality related to the search component.
 */
define([], function() {
  let Search = {

    /**
     * Global variable initilised to save facet values
     */
    refinementValuesArray: {},
    /* Local object variable to construct selected facet name-value pairs*/
    refinementTestObj: {},
    selectedCategoryLabel: '',
    keyword: null,
    dept: null,
    pageSize: null,
    currentPage: null,
    sortBy: null,
    minPrice: null,
    maxPrice: null,
    refine: null,
    isCategoryPage: false,
    spellCheck: false,
    executed: false,


    /* Apply facet*/
    buildRefinedURL: function(o) {
      let isChecked;
      let clickedValue;
      let clickedLabel;
      let clickedName;
      let valueIndex;
      let nameIndex = null;


      isChecked = $(o).is(':checked');
      clickedValue = $(o).val();
      clickedLabel = $(o).attr('data-title');
      clickedName = $(o).attr('parent-name');
      let searchString = $(o).attr('base-url');

      searchString = searchString + ((searchString.indexOf('?') == -1) ? '?' : '');

      clickedName = this.facetEncodedUrl(clickedName);
      clickedLabel = this.facetEncodedUrl(clickedLabel);

      if (this.refinementValuesArray != undefined && this.refinementValuesArray != null) {
        if (this.refinementValuesArray.hasOwnProperty(clickedName)) {
          valueIndex = this.refinementValuesArray[clickedName].indexOf(clickedValue);
        }
      }

      if (isChecked) {
        if (valueIndex == null || valueIndex == undefined || valueIndex == -1) {
          if (this.refinementValuesArray.hasOwnProperty(clickedName)) {
            this.refinementValuesArray[clickedName].push(clickedValue);
          } else {
            this.refinementValuesArray[clickedName] = [];
            this.refinementValuesArray[clickedName].push(clickedValue);
          }
        }
        if ($('#isBDAppVar').val() != 'BD') {
          // construct this object to set selected facet name-value pairs in the URL.

          if (this.refinementTestObj != undefined && this.refinementTestObj != null && this.refinementTestObj.hasOwnProperty(clickedName)) {
            this.refinementTestObj[clickedName].push(clickedLabel);
          } else {
            this.refinementTestObj[clickedName] = [];
            this.refinementTestObj[clickedName].push(clickedLabel);
          }
        }
      } else {
        if (valueIndex != null && valueIndex != undefined || valueIndex > -1) {
          this.refinementValuesArray[clickedName].splice(valueIndex, 1);
        }
        if ($('#isBDAppVar').val() != 'BD') {
          // Remove the facet name-value pair from the object if the URL is not empty.
          if (this.refinementTestObj != undefined && this.refinementTestObj != null && this.refinementTestObj.hasOwnProperty(clickedName)) {
            nameIndex = this.refinementTestObj[clickedName].indexOf(clickedLabel);
            if (nameIndex != null && nameIndex > -1) {
              this.refinementTestObj[clickedName].splice(nameIndex, 1);
              if (this.refinementTestObj[clickedName].length == 0) {
                // Remove the entire object if no record exists.
                delete this.refinementTestObj[clickedName];
              }
            }
          }
        }
      }

      if ($('#isBDAppVar').val() != 'BD') {
        // Construct the facet name-value as URL parameter in the facet
        for (let keys = Object.keys(this.refinementTestObj).sort(), i = 0, end = keys.length; i < end; i++) {
          let key = keys[i];
          let value = [];
          value = this.refinementTestObj[key];
          if (value != undefined && value != null && value.length > 0) {
            // Display the selected values in alphabetical order
            value.sort();
            searchString += '&' + key + '=' + value.join('+');
          }
        }
      }

      searchString += ((this.keyword != undefined && this.keyword != '') ? ('&keyword=' + this.encodeUrl(this.keyword)) : '') + ((this.sortBy != undefined && this.sortBy != '') ? ('&sortBy=' + this.sortBy) : '') +
        ((this.minPrice != undefined && this.minPrice != '') ? ('&minPrice=' + this.minPrice) : '') + ((this.maxPrice != undefined && this.maxPrice != '') ? ('&maxPrice=' + this.maxPrice) : '') +
        ((this.dept != undefined && this.dept != '') ? ('&dept=' + this.dept) : '');

      if (this.refinementValuesArray != undefined && this.refinementValuesArray != null && Object.keys(this.refinementValuesArray).length > 0) {
        searchString = searchString + '&refine=';
        for (let keys = Object.keys(this.refinementValuesArray).sort(), i = 0, end = keys.length; i < end; i++) {
          let key = keys[i];
          let value = [];
          value = this.refinementValuesArray[key];
          if (value != undefined && value != null && value.length > 0) {
            // Price Less than $25 should come first in selected display title
            if (value.includes('MIN_PRICE%3A%28%7B*+25%7D%29')) {
              let j = value.indexOf('MIN_PRICE%3A%28%7B*+25%7D%29');
              if (j != -1) {
                value.splice(j, 1);
              }
              value.sort();
              value.unshift('MIN_PRICE%3A%28%7B*+25%7D%29');
            } else {
              value.sort();
            }
            // Display the selected values in alphabetical order
            for (let index in value) {
              searchString += this.encodeUrl(value[index]) + '|';
            }
          }
        }
        // Remove the refine param if it is empty  - SEO recommendation
        if (!(searchString.indexOf('&refine=') == -1)) {
          let refineUndefined = this.getUrlParam('refine', searchString);
          if (!refineUndefined) {
            searchString = searchString.replace('&refine=', '');
          }
        }
      }
      // Remove the &amp if exists without URL paramater
      if (!(searchString.indexOf('?&') == -1)) {
        searchString = searchString.replace('?&', '?');
      }
      // Remove the ? if exists without any URL parameters
      if (searchString.substr(searchString.length - 1, 1) == '?') {
        searchString = searchString.substr(0, searchString.length - 1);
      }

      window.location = searchString;
    },
    getURLParameter: function(sParam) {
    	var sPageURL = window.location.search.substring(1);
    	var sURLVariables = sPageURL.split('&');
    	for (var i = 0; i < sURLVariables.length; i++) {
    		var sParameterName = sURLVariables[i].split('=');
    		if (sParameterName[0] == sParam) {
    			return sParameterName[1];
    		}
    	}
    },
    getAllURLParams: function(url, asString) {
    	console.log("url working with: "+url);	
    	if (url) {
    		var sPageURL = url;
    	} else {
    		var sPageURL = window.location.search.substring(1);
    	}
    	var sURLVariables = sPageURL.split('&');
    	var cleanedUpParams = sURLVariables.filter(function (el) {
    	    return el != null && el != "";
    	  });
    	return cleanedUpParams;
    },
    buildLucidWorksRefinedURL: function(o) {
    	let isChecked;
        let clickedValue;
        let newFilterUrl = null;
        let sortByParam = null;
        let deliveryFacetUnchecked=null;
        
        isChecked = $(o).is(':checked');
        clickedValue = encodeURI($(o).val()).replace( /\+/g, '%2B' );
        let facetLabel = $(o).attr('parent-name').replace(/\s/g, '-').toLowerCase();
        let selectedFacetVal = $(o).attr('english-name').replace('&', 'and').replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '').replace(' to ', '-').replace(/\s/g, '-').toLowerCase();
        let searchString = $(o).attr('data-url');
        let baseURLString = $(o).attr('base-url');
        
        let currSeoParams;
        var seoParams='';
        console.log("facetLabel ="+facetLabel);
        console.log("selectedFacetVal ="+selectedFacetVal);
        
        var deliveryCheckedFlag=$("[id^='facet_option_Program_Eligibility_ShipIt']:checked").length>0 ? true: false ; 
        deliveryFacetUnchecked= "&deliveryFacetFlag="+deliveryCheckedFlag; // ALM 47455
        
        if($(o).attr('parent-name') === 'Hide Unavailable Items' || $(o).attr('parent-name') === 'costcoprogramtypes' || $(o).attr('parent-name') === 'cacher-les-articles-non-offerts'){
	        if(xappDeliveryFacet && deliveryCheckedFlag && !searchString.includes('item_program_eligibility-ShipIt') && !clickedValue.includes("item_program_eligibility-ShipIt" )){
	        	if(!searchString.includes('refine')){
	        		searchString = "refine=||item_program_eligibility-ShipIt";
	        	}else{
	        		searchString=searchString+'||item_program_eligibility-ShipIt';
	        	}
	        }
        }
        var showUnavailableItems = 'hide-unavailable-items';
        if((facetLabel==showUnavailableItems || facetLabel =='cacher-les-articles-non-offerts')&& xappShowOutOfStockFacet){
        		isChecked = !isChecked;       		 
        }
       
        if(isChecked){
        	var test = Search.getURLParameter(facetLabel);
        	if(Search.getURLParameter(facetLabel) && Search.getURLParameter(facetLabel) != null){
        		currSeoParams = '&'+facetLabel+'='+Search.getURLParameter(facetLabel)+"+"+selectedFacetVal;
        	}else{
        		currSeoParams = '&'+facetLabel+'='+selectedFacetVal;
        	}
        	searchString=searchString+'||'+clickedValue;
        	
        	let entries = Search.getAllURLParams();
        	for(var i=0, len=entries.length; i<len; i++) {
        		var entry = entries[i].split('=');
        		if(entry[0]!= 'keyword' && entry[0]!='refine' && entry[0]!='sortBy' && entry[0]!='currentPage' && entry[0]!='pageSize' && entry[0]!='searchProvider' && entry[0]!='deliveryFacetFlag'){
        			if(entry[0] !== facetLabel && entry[0] != null) {
        				seoParams=seoParams+'&'+entry[0]+'='+entry[1];
        			}
        		}
        	}
    		seoParams=seoParams+currSeoParams;
    		seoParams.trim();
    		seoParams = Search.getAllURLParams(seoParams);
    		seoParams.sort();
    		if (seoParams.length > 1) {
    			seoParams = seoParams.toString().replace(/\,/g, '&');
    		}
    		console.log('seoParams ='+seoParams);
        	
        	newFilterUrl= baseURLString+'&'+seoParams+deliveryFacetUnchecked+'&'+searchString;
        }else{
        	var urlParams = Search.getURLParameter(facetLabel);
        	//here we work just w facet label query params
        	if(urlParams !=null && urlParams.indexOf('+')!==-1){
        		let selectedParamsArr = urlParams.split('+');
        		for (index = 0; index < selectedParamsArr.length; index++){
        			if(selectedFacetVal != selectedParamsArr[index]){
	        			if(!currSeoParams)
	        				currSeoParams = selectedParamsArr[index];
	        			else
	        				currSeoParams = currSeoParams+'+'+selectedParamsArr[index];
        			}
        		}
        		currSeoParams='&'+facetLabel+'='+currSeoParams;
        		console.log(urlParams.split('+').length+"---->"+currSeoParams);
        	}else{
        		currSeoParams='';
        	}
        	
        	//here we handle the remaining query params
        	let entries = Search.getAllURLParams(seoParams);
			console.log("work with remainder: "+entries);
        	for(var i=0, len=entries.length; i<len; i++) {
        		var entry = entries[i].split('=');
        		var entryLabel = entry[0];
        		if(entryLabel!= 'keyword' && entryLabel!='refine' && entryLabel!='sortBy' && entryLabel!='currentPage' && entryLabel!='pageSize' && entry[0]!='searchProvider' && entryLabel!='deliveryFacetFlag'){
        			if(entryLabel !== facetLabel && entryLabel != null)
        				seoParams=seoParams+'&'+entryLabel+'='+entry[1];
        		}
        	}
        	seoParams=seoParams+currSeoParams;
        	seoParams.trim();
        	if(seoParams!==null && seoParams!==''){
        		seoParams = Search.getAllURLParams(seoParams);
        		seoParams.sort();
        	}
        	if (seoParams.length > 1) {
    			seoParams = seoParams.toString().replace(/\,/g, '&');
    		}
        	
        	searchString=searchString.replace('%7C%7C'+clickedValue,'');
        	if(searchString.substring(searchString.indexOf('=')+1,searchString.length).length>0){
        		newFilterUrl= baseURLString+'&'+seoParams+deliveryFacetUnchecked+'&'+searchString;
        	}
        	else{
        		newFilterUrl =baseURLString+deliveryFacetUnchecked;
        	}	
        }
        //Get the SortBy Param and append to the URL
        var urlParams = Search.getURLParameter('sortBy');
        if(urlParams){
        	sortByParam='&sortBy='+urlParams; 
        	newFilterUrl = newFilterUrl+sortByParam;
        }
        if (baseURLString.indexOf('?') == -1) {
        	newFilterUrl = newFilterUrl.replace('&','?');
        }
        console.log("newFilterUrl ="+newFilterUrl);
        window.location.href = newFilterUrl;
    },
    getUrlParam: function(name, url) {
      let results = new RegExp('[\\?&]' + name + '=([^&#]*)').exec(url);
      return (results && results[1]) || undefined;
    },

    facetEncodedUrl: function(refine) {
      return refine.replace(/&/g, 'and').replace(/\s-\s/g, '-').replace(/\s/g, '-').replace(/[^a-zA-Z0-9-]/g, '').toLowerCase();
    },

    encodeUrl: function(url) {
      return encodeURIComponent(url).replace(/'/g, '%27').replace(/"/g, '%22');
    },
    /* Build Department Facet*/
    buildDeptURL: function(element) {
      // var url = $(element).data('url');
      let url = $(element).attr('base-url');
      let encodedKeyword = encodeURIComponent(this.keyword);
      url = url + ((url.indexOf('?') == -1) ? '?' : '');
      deptVar = '';
      if ($('#isBDAppVar').val() != 'BD') {
        if (this.spellCheck == 'true') {
          url += '&spellCheck=true';
        }
        // Construct the facet name-value as URL parameter in the facet
        for (let keys = Object.keys(this.refinementTestObj), i = 0, end = keys.length; i < end; i++) {
          let key = keys[i];
          let value = [];
          value = this.refinementTestObj[key];
          if (value != undefined && value != null && value.length > 0) {
            // Display the selected values in alphabetical order
            value.sort();

            url += '&' + key + '=' + value.join('+');
          }
        }
        let isGroceryFilterSelected = $('#is_grocery_Filter_Selected').val();
        bannerCrumbsList = $('#crumbs_ul li');
        type = 'Grocery';


        if (undefined != this.dept && this.dept != null && this.dept == type) {
          deptVar = type;
        } else if (bannerCrumbsList.length != 0 && (url.substr(url.lastIndexOf('/') + 1, 17) == 'grocery-household' ||
            bannerCrumbsList[1].textContent.trim().indexOf('Grocery') > -1)) {
          deptVar = type;
        } else if (null != isGroceryFilterSelected && isGroceryFilterSelected == 'true') {
          deptVar = type;
        }
        url += ((this.keyword != undefined && this.keyword != '') ? ('&keyword=' + encodedKeyword) : '') + ((this.sortBy != undefined && this.sortBy != '') ? ('&sortBy=' + this.sortBy) : '') +
          ((this.minPrice != undefined && this.minPrice != '') ? ('&minPrice=' + this.minPrice) : '') + ((this.maxPrice != undefined && this.maxPrice != '') ? ('&maxPrice=' + this.maxPrice) : '') +
          ((deptVar != '') ? ('&dept=' + deptVar) : '');
      } else {
        // If applicable for BD
        url += ((this.keyword != undefined && this.keyword != '') ? ('&keyword=' + encodedKeyword) : '') + ((this.pageSize != undefined && this.pageSize != '') ? ('&pageSize=' + this.pageSize) : '') + ((this.sortBy != undefined && this.sortBy != '') ? ('&sortBy=' + this.sortBy) : '') +
          ((this.minPrice != undefined && this.minPrice != '') ? ('&minPrice=' + this.minPrice) : '') + ((this.maxPrice != undefined && this.maxPrice != '') ? ('&maxPrice=' + this.maxPrice) : '') +
          ((this.dept != undefined && this.dept != '') ? ('&dept=' + this.dept) : '');
      }


      if (this.refinementValuesArray != undefined && this.refinementValuesArray != null && Object.keys(this.refinementValuesArray).length > 0) {
        url = url + '&refine=';
        for (let keys = Object.keys(this.refinementValuesArray).sort(), i = 0, end = keys.length; i < end; i++) {
          let key = keys[i];
          let value = [];
          value = this.refinementValuesArray[key];
          if (value != undefined && value != null && value.length > 0) {
            // Price Less than $25 should come first in selected display title
            if (value.includes('MIN_PRICE%3A%28%7B*+25%7D%29')) {
              let j = value.indexOf('MIN_PRICE%3A%28%7B*+25%7D%29');
              if (j != -1) {
                value.splice(j, 1);
              }
              value.sort();
              value.unshift('MIN_PRICE%3A%28%7B*+25%7D%29');
            } else {
              value.sort();
            }
            // Display the selected values in alphabetical order
            for (let index in value) {
              url += this.encodeUrl(value[index]) + '|';
            }
          }
        }
      }


      // Remove the &amp if exists without URL paramater
      if (!(url.indexOf('?&') == -1)) {
        url = url.replace('?&', '?');
      }
	  
	    if (isNaN(url.charCodeAt(url.indexOf('?')+1))) {
          url = url.replace('?', '');
      }

      window.location.href = url;
    },
    /**
     * The initializing function modules use
     * to call.
     * @return {[type]} [description]
     */

    init: function init() {
      let resultView = COSTCO.util.getFromStorage('result_view').result_view;
      let wW = $(window).width();
      let defaultView = 'grid';
      if (wW < 769) {
    	  defaultView = 'list';
      }
      // Grid view set as default, and is overridden if user has selected list view
      if (resultView == null) {
    	  COSTCO.util.safe(this.toggle_view)(defaultView);
      } else {
    	  COSTCO.util.safe(this.toggle_view)(resultView);
      }
      // Commented  for facet build
      // COSTCO.util.safe(this.build_filter)();
      COSTCO.util.safe(this.back_to_top)();
      COSTCO.util.safe(this.decodePrice)();
      COSTCO.Header.miniShopCartRefresh();
      COSTCO.Header.refreshGroceryOrderParams();
      COSTCO.util.safe(this.popovers());
      
      // For ADA it is important that NVDA catch change of checkbox state before calls onclick function.
      // Any timeout duration will be enough. onclick must be added with JS, for proper NVDA usage.
      document.querySelectorAll('[id^="facet_option_"]').forEach(element => {
    	  element.addEventListener("click",function(){
    		  setTimeout(() => {
    			  COSTCO.Search.buildLucidWorksRefinedURL(element);
			  }, "50");
		  });
      });
      
      // Code added to hide result Count Message , on search page , if product spotlight message if available
      this.hideResultsCountMessage();
      if (typeof(displayCategoryList) !== 'undefined' && displayCategoryList) {
    	$(window).on('load',function() {
          if(COSTCO.util.getScreenType() === 'DESKTOP') {
            let insertTitleInList = $('#displaySmallerTitle').val() === 'true';
            COSTCO.Search.populateCategoryListLinks(elementClassId, insertTitleInList);
            if (insertTitleInList) {
              COSTCO.Search.switchMainCategoryTitles();
            }
          }
        });
      }
      
      
      if (typeof(categoryCList) !== 'undefined' && categoryCList) {
    	  this.configureShopByCatShowMoreButton();
      }

      COSTCO.Search.markCollectionTitle();

    },

    /**
     * Marks collection page title with the class "collection-title"
     */
    markCollectionTitle: function() {
      if ($('#collectionsPage').val()){
        $('#category-name-header').closest('.search-results-tile').addClass('collection-title'); 
      }
    },

    /**
     * This is used to decode a base64 encoded
     * price which was done to obfuscate the price
     * from google search results when membership only
     * prices were involved
     */

    decodePrice: function() {
      let memberCookie = COSTCO.util.getMemberCookie();
      let signedIn = memberCookie.signedIn || false;
      let isMember = memberCookie.costcoMember || false;
      let isValidated = memberCookie.validated || false;
      let isActive = memberCookie.active || false;
      // This check is added to keep BD flow unaffected by the change in BC flow
      let decodePrice = COSTCO.util.isBusinessDelivery() ? signedIn && isMember : signedIn && isMember && isValidated && isActive;
      if (decodePrice) {
        $('[data-encoded-min-price]').each(function() {
          let decodedPriceValue = COSTCO.util.decode($(this).data('encoded-min-price'));
          $(this).text(decodedPriceValue);
        });
        $('[data-encoded-formatted-inclusive-price]').each(function() {
          let decodedPriceValue = COSTCO.util.decode($(this).data('encoded-formatted-inclusive-price'));
          $(this).text(decodedPriceValue);
        });
      }
    },
    /**
     * This is used inline by the grid/list view
     * buttons within the search results page to switch
     * the view between "grid" or "list" view
     * @param  {String} view - "grid" or "list"
     * @return {void}
     */
    toggle_view: function(view) {
      if (document.getElementById('search-results')) {
        let present_view = $('.product-list').hasClass('list') ? 'list' : 'grid',
          $products = $('.product-list .product'),
          $hr = $('.product-list hr'),
          $list_icon = $('.list a'),
          $grid_icon = $('.grid a');
        if (view == 'list' && present_view != 'list') {
          let wW = $(window).width();
          let wrappingList = '';
          if (wW > 375) {
            wrappingList = ', .addbutton';
          }
          $products.each(function(i, product) {
            $(product).removeClass().addClass('product col-xs-12');
            $(product).find('.product-img-holder').wrapAll('<div class="col-xs-6 col-md-4 col-xl-3"></div>');
            $(product).find('.caption, .compare-container, .btn-out-of-stock' + wrappingList).wrapAll('<div class="col-xs-6 col-md-8 col-xl-9"></div>');
            $(product).find('.menu-hold-diff').addClass('col-xl-4');
            $(product).find('.menuicon-holder').addClass('col-xl-12');
            $(product).find('.product-quick-buy').parent().addClass('col-lg-9 col-xl-4');
            $(product).find('.badge-class').addClass('menuicon-holder col-xl-4');
            $(product).find('.badge-holder1').addClass('col-xs-8 col-md-6 col-lg-5');
            $(product).find('.badge-holder1').removeClass('col-xs-6 col-md-8 col-lg-9');
            $(product).find('.badge-holder2').addClass('col-xs-4 col-md-6 col-lg-7 col-xl-4');
            $(product).find('.badge-holder2').removeClass('col-xs-6 col-md-4 col-lg-3 col-xl-12');
            
            if($(product).attr('id')!=null && $(product).attr('id').indexOf("_Banner") !== -1){
        		$(product).css("padding-top", "20px");
        	}
          });
          $products.last().addClass('last');
          $list_icon.addClass('active');
          $list_icon.attr('aria-current','true');
          $grid_icon.removeClass('active');
          $grid_icon.removeAttr('aria-current');
          $('.product-list').removeClass('grid').addClass('list');
          $hr.addClass('hide');
          COSTCO.util.setInStorage('result_view', {
            'result_view': 'list',
          });
        } else if (view == 'grid' && present_view != 'grid') {
          $products.each(function(i, product) {
        	if($(product).attr('id')!=null && $(product).attr('id').indexOf("_Banner") !== -1){
        		$(product).removeClass().addClass('col-xs-12 col-md-12 col-lg-12 col-xl-12 product');
        		$(product).removeAttr("style");
        	}else{
        		$(product).removeClass().addClass('col-xs-6 col-md-6 col-lg-4 col-xl-3 product');
        	}
            $(product).find('.product-img-holder').unwrap();
            $(product).find('.caption').unwrap();
            $(product).find('.badge-class').removeClass('menuicon-holder col-xl-4');
            $(product).find('.menuicon-holder').removeClass('col-xl-12');
            $(product).find('.menuicon-holder').removeClass('col-xl-4');
            $(product).find('.product-quick-buy').parent().removeClass('col-lg-9 col-xl-4');
            $(product).find('.badge-holder1').addClass('col-xs-6 col-md-8 col-lg-9');
            $(product).find('.badge-holder1').removeClass('col-xs-8 col-md-6 col-lg-5');
            $(product).find('.badge-holder2').addClass('col-xs-6 col-md-4 col-lg-3');
            $(product).find('.badge-holder2').removeClass('col-xs-4 col-md-6 col-lg-7 col-xl-4');
          });
          $grid_icon.addClass('active');
          $grid_icon.attr('aria-current','true');
          $list_icon.removeClass('active');
          $list_icon.removeAttr('aria-current');
          $('.product-list').removeClass('list').addClass('grid');
          $hr.removeClass('hide');
          COSTCO.util.setInStorage('result_view', {
            'result_view': 'grid',
          })
          COSTCO.Header.align_quickbuy_btn();
        }
        // COSTCO.Header.align_quickbuy_btn();
        
        //React swatches rerender
    	window.wioEventBus.publish('toggleView', {'view': view});

      }
    },
    /**
     * Creates an array of objects to be built out as filter refinements
     * specific to the costco.ca region selected
     * @param  {[type]} region - the region selected
     * @param  {[type]} filter_items - filterjson items to be filtered
     * @return {[array]} resultant_array - the array of objects
     */
    region_items: function(region, filter_items) {
      region = region || 'CAAB'; // If region is null, default to Alberta
      let region_objs_array = [],
        resultant_array = [];
      // First get the objects that are specific to the current region aka
      // object.region == region.
      filter_items.forEach(function(item, index) {
        if (item.r == region) {
          region_objs_array.push(item);
        }
      });
      // Now use the region objects to determine what gets pushed into the
      // resultant array
      filter_items.forEach(function(item, index) {
        let is_region_item = COSTCO.util.any(region_objs_array, function(obj) {
          return obj.n == item.n;
        });
        // If the item is one that we know has a region specific value
        if (is_region_item) {
          // if the item.region matches the region we want
          if (item.r == region) resultant_array.push(item);
        } else {
          // We don't want a region specific item
          if (!item.r.match(/CA/)) resultant_array.push(item);
        }
      });
      return resultant_array;
    },
    /**
     * Get the number of active refinements. Uses the &refine= querystring
     * @return {[number]} count - the number of refinements that are active
     */
    get_refinement_count: function() {
      let refinements = COSTCO.util.getParameterByName('refine'),
        count = 0;
      if (refinements) {
        count = refinements.split(' ').filter(function(refinement) {
          // filter out blanks
          if (refinement) return refinement;
        }).length;
      }
      return count;
    },
    /**
     * Attached to a.clear-filter. Redirects to the proper URL.
     * If 'keyword' direct to a.clear-filter[data-url] else go to path. This
     * URL will not include any refinements.
     * @return {[void]}
     */
    clear_filter: function() {
      COSTCO.util.getParameterByName('keyword') ?
        location.href = $(this).data('url') :
        location.href = location.pathname;
    },
    /**
     * Utility method to clean the URL and return a parameterized string
     * It takes in a javascript object and returns a decoded URI string.
     * This is specific to the named keyword / value pairs in the url (ie - brand=samsung+vizio)
     * @return String
     */
    clean_url: function(dimensionNameObj) {
      let searchValues = '',
        u = COSTCO.util,
        searchNameObject = {},
        searchString = '';

      Object.keys(dimensionNameObj)
        .sort(function(a, b) {
          if (a == 'brand') {
            return -1;
          } else if (b == 'brand') {
            return 1;
          } else {
            return a > b;
          }
        })
        .forEach(function(key) {
          searchValues = u.interpolate(dimensionNameObj[key], '+').join('');
          searchValues = searchValues.replace(/\$/g, '').toLowerCase();
          searchValues = searchValues.replace(/\s/g, '-');
          searchValues = searchValues.replace(/\s*:/g, 'x');
          searchValues = searchValues.replace(/,/g, '');
          searchValues = searchValues.replace(/in./g, 'inches');
          searchValues = searchValues.replace(/\./g, '-');
          searchValues = searchValues.replace(/\(|\)/g, '');
          searchValues = searchValues.replace(/-{2,}/g, '-');
          searchValues = searchValues.replace(/\&/g, 'and');
          key = key.replace(/\s/g, '-');
          key = key.replace(/'/g, '-');
          searchNameObject[key] = searchValues;
        });

      searchString = $.param(searchNameObject, true);
      searchString = decodeURIComponent(searchString);
      return searchString; ;
    },
    /**
     * This is the event handler on the filter link for smaller resolutions on search
     * results to invoke a filter modal. The function ensures that only one representation
     * of the filter exists at one time in an effort to conserve client memory.
     * @return {[void]}
     */

    filter_modal: function() {
    	let version_sufix = "";
    	if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CATEGORY_FEATURE_ENABLE){
    		version_sufix = "_v2";
    	}
      let filter_html = document.getElementById('accordion-filter').outerHTML + COSTCO.util.tmpl('tmpl_filter_buttons'+version_sufix, {});
      $('#accordion-filter').remove();
      $('.modal-footer').addClass('hide');
      COSTCO.dialog.createExtDialogBox({
        title: messages.RWD_TOOLBAR_FILTER,
        body: filter_html,
        onclose: function() {
          $('#search-filter').append(document.getElementById('accordion-filter').outerHTML);
          $('.modal-footer').removeClass('hide');
        },
        dialogclasses: 'filter-modal',
      });
      // For ADA it is important that NVDA catch change of checkbox state before calls onclick function.
      // Any timeout duration will be enough. onclick must be added with JS, for proper NVDA usage.
      document.querySelectorAll('[id^="facet_option_"]').forEach(element => {
    	  element.addEventListener("click",function(){
    		  setTimeout(() => {
    			  COSTCO.Search.buildLucidWorksRefinedURL(element);
			  }, "50");
		  });
      });
    },


    /**
     * The prerequisite for for this function to build a search filter is the existence
     * of the parent accordion div#accordion-filter and a "filterjson" object. This function
     * attaches accordion panels to the parent accordion with their corresponding dimension
     * options. This function also hides dimensions that have a count higher than 5 for each
     * parent dimension. This function will then open a panel if there is a selected dimension
     * within that panel.
     * @return {[void]}
     */
    build_filter: function() {
      if (typeof filterjson !== 'undefined') {
        let c = COSTCO.Search,
          u = COSTCO.util,
          filter_items = filterjson[0].items,
          query_parms_object = u.get_parameters_as_object();

        let has_grocery_identifier = $('#has_grocery_identifier').val();

        let searchType = $('#selected-type').val();
        // If we're in Canada, we need to get the region specific filters
        if (wcs.locale == 'en_CA' || wcs.locale == 'fr_CA') {
          filter_items = c.region_items(COSTCO.util.getRegion(), filter_items);
        }
        // Build the accordion panels
        filter_items.forEach(function(item, index) {
          // Start - BaB items Left Nav Filter
          if (item.n == 'CostcoProgramTypes') {
            if (item.items) {
              item.items.forEach(function(sub, i) {
                if (sub.s) {
                  currentUrl = '';
                }

                if (!(sub.c && sub.s) && sub.n == '1') { // No selected checkboxes with counts
                  // build a dimension checkbox
                  $('#grocery-filter').append(COSTCO.util.tmpl('tmpl_filter_grocery_attr', {
                    id: 'refinement_' + index + '-' + i,
                    name: sub.n,
                    selected: sub.s ? 'checked' : '',
                    url: sub.u ? sub.u : '',
                    dimension: sub.v ? sub.v : sub.d ? sub.d : '',
                    dimensionname: sub.o,
                    parentname: sub.p,
                    englishname: sub.e,
                  }));
                }
              });
            }
          } // End - BaB items Left Nav Filter
          else { // Added else for BaB items Left Nav Filter
            COSTCO.util.accordion_addon('accordion-filter', item.n, // header of accordion panel is the name
              (function(item, parent_index) { // body of the accordion panel is sub categories
                let filter_html_string = '';
                if (item.items) {
                  let is_cat_selected = c.is_cat_selected(filterjson[0].items);
                  item.items.forEach(function(sub, i) {
                    if (searchType == 'Grocery' && sub.u.includes('?')) {
                      var currentUrl = sub.u + '&identifier=grocery-household&dept=Grocery';
                    } else if (searchType == 'Grocery' && !sub.u.includes('?')) {
                      var currentUrl = sub.u + '?identifier=grocery-household&dept=Grocery';
                      // sasi
                      // currentUrl="";
                    } else {
                      var currentUrl = sub.u;
                    }
                    if (item.d == 'CATEGORY') {
                      let is_diff_cat = is_cat_selected && i == item.items.length - 1 ? true : false,
                        filter_string = COSTCO.util.tmpl('tmpl_filter_cat', {
                          selected: sub.s ? 'selected' : '',
                          name: sub.n,
                          count: sub.c ? sub.c : '',
                          url: currentUrl,
                          dimension: sub.v ? sub.v : sub.d ? sub.d : '',
                          diff_cat: is_diff_cat ? 'diff-cat' : '',
                          current_cat: c.is_current_cat(sub, filterjson[0].items) ?
                            'current' : '',
                        });
                      // Hoisting "Select a Different Category" to the top
                      is_diff_cat
                        ?
                        filter_html_string = filter_string + filter_html_string :
                        filter_html_string += filter_string;
                    } else if (!(sub.c && sub.s)) { // No selected checkboxes with counts
                      // build a dimension checkbox
                      if (sub.s) {
                        currentUrl = '';
                      }
                      filter_html_string += COSTCO.util.tmpl('tmpl_filter_attr', {
                        id: 'refinement_' + index + '-' + i,
                        name: sub.n,
                        selected: sub.s ? 'checked' : '',
                        url: currentUrl,
                        count: sub.c ? sub.c : '',
                        dimension: sub.v ? sub.v : sub.d ? sub.d : '',
                        dimensionname: sub.o,
                        parentname: sub.p,
                        englishname: sub.e,
                      });
                    }
                  });
                }
                return filter_html_string;
              })(item, index), '', false);
          } // BaB items Left Nav Filter
        });
        // If the selected category depth is > 1 we need to append a class to the
        // .panel-body of the category to make the padding work correctly.
        if (c.get_cat_depth(filterjson[0].items) > 1) {
          $('#accordion-filter .panel-collapse .panel-body').first().addClass('big');
        }
        // No more than 5 dimensions showing at once. Give "Show More Options" link
        $('#accordion-filter .panel-collapse .panel-body').each(function(i, panel) {
          let $style_check = $(panel).find('.style-check');
          $style_check.each(function(k, style_check) {
            if (k > 4) {
              $(style_check).addClass('hide');
            }
          });
          if ($style_check.length > 5) {
            $style_check.parent().append(COSTCO.util.tmpl('tmpl_filter_more', {}));
          }
        });
        // Open an accordion panel if there is active refinement in that panel
        $('input.dimension:checked, .style-check.selected')
          .parents('.panel-collapse').siblings().trigger('click');
        // Open the first two accordion panels if we're >= tablet portrait
        // regardless of selection
        if (window.innerWidth > 667) {
          $('#accordion-filter .panel-heading').slice(0, 2).trigger('click');
        }
        // Add the number of filters applied next to the Filter link (ex. Filter (3))
        let refinement_count = c.get_refinement_count();
        if (refinement_count > 0) {
          $('#filterbutton').append('(' + refinement_count + ')');
        }
        // Limit number of previous subcategories to last two levels.
        let subcat_depth = $('.style-check.selected:not(.current)').length;
        if (subcat_depth > 2) {
          $('.style-check.selected:not(.current)').first().addClass('hide');
        }
        // Build the sort filter
        Search.build_sort_filter();
      }
    },
    build_sort_filter: function() {
      let currentURL = window.location.href,
        u = COSTCO.util,
        qso = {};

      currentURL = u.removeParam('sortBy', currentURL);

      $('select#sort_by option').each(function(i, elem) {
        qso.sortBy = decodeURI(elem.value);
        let sortUrl = u.makeUrl(currentURL, qso);
        sortUrl = decodeURI(sortUrl);
        $(elem).data('url', sortUrl);
      });
    },

    redirect_based_on_sort: function() {
      window.location.href = $(this).find('option:selected').data('url');
    },

    build_category_url: function(url, objArr, refineId) {
      let u = COSTCO.util,
        finalUrl = '';
      Object.keys(objArr).forEach(function(key) {
        if (key == 'refine') {
          if (!refineId.includes('+')) {
            objArr[key] = objArr[key] + '+' + refineId;
          }
          let refineArr = objArr[key].split('+');

          refineArr = u.unique(refineArr);
          refineArr.sort();
          objArr[key] = refineArr.join('+');
        }
      });

      let queryString = decodeURIComponent($.param(objArr));
      finalUrl = url + '?' + queryString;
      return finalUrl;
    },


    /**
     * Loop through the filterjson and determine if at least one category is selected
     * @param  {[array]} objArr - the array of objects representing filter dimensions.
     * @return {Boolean}
     */
    is_cat_selected: function(objArr) {
      let is_selected = false;
      objArr.forEach(function(parent, i) {
        if (parent.d == 'CATEGORY') {
          parent.items.forEach(function(child, j) {
            if (child.s) {
              is_selected = true;
              return;
            }
          });
        }
        if (is_selected) return;
      });
      return is_selected;
    },
    /**
     * Is the parameter 'category' the currently selected category?
     * @param  {[object]} category - The object rerpesenting the category to test against.
     * @param  {[array]} objArr - the array of objects representing filter dimensions.
     * @return {Boolean}
     */
    is_current_cat: function(category, objArr) {
      let is_current = false,
        last_cat;
      objArr.forEach(function(parent, i) {
        if (parent.d == 'CATEGORY') {
          parent.items.forEach(function(child, j) {
            if (child.s) {
              last_cat = child.n;
            }
          });
        }
      });
      if (category.n == last_cat && category.s) {
        is_current = true;
      }
      return is_current;
    },
    /**
     * returns the most recently selected category (ie - what category page am I on)
     * @return {string}
     */
    get_current_cat: function() {
      let current_cat = $('.current.selected label').text().trim();
      return current_cat;
    },
    /**
     * Get the depth of categories that are selected
     * @param  {[array]} objArr - the array of objects representing filter dimensions.
     * @return {[number]} The depth of categories that are selected
     */
    get_cat_depth: function(objArr) {
      let depth = 0;
      objArr.forEach(function(parent, i) {
        if (parent.d == 'CATEGORY') {
          parent.items.forEach(function(child, j) {
            if (child.s) {
              depth++;
            }
          });
        }
      });
      return depth;
    },
    /**
     * This is an inline event handler that is located on the "Show More Options" link
     * built out by COSTCO.Search.build_filter. It first removes the hide classes on
     * style-checks and then deletes itself. Also sets focus on next element.
     * @return {[void]}
     */
    reveal_options: function() {
      $(this).parent().siblings(".hide:first").addClass("first-new");
	      $(this).parent().siblings().removeClass("hide");
        $(this).parent().siblings(".first-new").find('a').focus();
        $(this).parent().siblings(".first-new").find('label').focus();
	      $(this).parent().siblings().removeClass("first-new");
	      $(this).parent().remove();  
    },
    /**
     * Pop over for special order products in product tiles.
     *
     */
    popovers: function() {
      $('#search-results .special-order>a').each(function() {
        $(this).popover({
          trigger: 'focus',
          container: $(this).closest('.menuicon-holder').find('[special-order-popover-holder]'),
        });
      });
    },
    /**
     * This is an inline event handler that is attached to each dimension input[checkbox]
     * within the accordion panels. The "if" condition is self explanatory. It simply redirects
     * to the url of the dimension if that attribute exists "else" the user deselected a
     * dimension and the relative url is built out and redirected to.
     * @param  {[Boolean]} isCategory - OPTIONAL - called from #tmpl_filter_cat
     * @return {[void]}
     */
    adjust_refinement: function(isCategory) {
      let u = COSTCO.util,
        url = $(this).data('url') || undefined,
        currentUrl = window.location.href;
      if (url) {
        window.location.href = url;
      } else {
        var keyword = u.getParameterByName('keyword'),
          sortByValue = u.getParameterByName('sortBy'),
          category = isCategory ?
          $(this).data('dimensionid') :
          $('.current.selected a').data('dimensionid'),
          category_dimension = category ? category + '+' : '',
          search = category_dimension ? category_dimension : '',
          searchName = '',
          dimensions = [],
          dimensionNameObject = {},
          searchNameObject = {},
          sortByObject = {},
          childNameArray = [];
        // This case (is_first_cat) represents when a category is selected and no other category is active.
        // We want to allow selecting a category if all other refinements are not categories.
        is_first_cat = ($('.style-check.selected').length == 0 ? true : false) && isCategory;
        if (!search.split('+').length > 1 || !isCategory || is_first_cat) {
          $('input.dimension:checked').each(function(i, dimension) {
            dimensions.push($(dimension).data('dimensionid'));

            let parentname = $(dimension).attr('parent-name');
            let childname = $(dimension).attr('name');
            if ($(dimension).attr('english-name') != '') {
              childname = $(dimension).attr('english-name');
            }

            if (dimensionNameObject.hasOwnProperty(parentname)) {
              childNameArray.push(childname);
              dimensionNameObject[parentname] = childNameArray;
            } else {
              childNameArray = [];
              childNameArray.push(childname);
              dimensionNameObject[parentname] = childNameArray;
            }
          });
        }

        if (dimensions.length == 0) {
          search = '';
        }

        search = search.replace(/\+/g, '');

        if (search != '') {
          dimensions.push(search);
        }

        dimensions = dimensions.sort(function(a, b) {
          return a - b;
        });

        search = u.interpolate(u.unique(dimensions), '+').join('');
        var searchName = Search.clean_url(dimensionNameObject);
        let searchType = $('#selected-type').val();

        let path = location.pathname + (searchName ? '?' + searchName : '') +
          (search ? (searchName ? '&refine=' + search : '?refine=' + search) : '') +
          (keyword ? (searchName ? '&keyword=' + keyword : search ? '&keyword=' + keyword : '?keyword=' + keyword) : '') +
          (sortByValue ? (searchName ? '&sortBy=' + sortByValue : search ? '&sortBy=' + sortByValue : keyword ? '&sortBy=' + sortByValue : '?sortBy=' + sortByValue) : '');

        if (searchType == 'Grocery' && path.includes('?')) {
          location.href = path + '&identifier=grocery-household&dept=Grocery';
        } else if (searchType == 'Grocery' && !path.includes('?')) {
          location.href = path + '?identifier=grocery-household&dept=Grocery';
        } else {
          location.href = path;
        }
      }
    },
    /**
     * back_to_top appends tmpl_back_top html (Templates.jspf) to the end of a
     * product list if that product list (in search results) doesn't have a
     * paging element (which has one already) and if a toolbar is present (as
     * to avoid puting one on a top level category).
     * @return {[void]}
     */
    back_to_top: function() {
      if ($('.toolbar').length > 0 && $('.paging').length == 0 && !costcoStoreFeatures.WEBSITE_REDESIGN_V2_CATEGORY_FEATURE_ENABLE) {
        $('.product-list').append(COSTCO.util.tmpl('tmpl_back_top', {}));
      }
    },
    hideResultsCountMessage() {
      if ($('.toolbar .rule-message .featureItemsTable li').length > 0) {
        $('.toolbar h1#rsltCntMsg').hide();
      }
    },
    /**
     * Fires the SearchLoaded event
     * @return {void}
     */
    loaded: function() {
      COSTCO.Global.notify('SearchLoaded');
    },
    /**
     * Uses the facet entry
     */
    solrRefinementUrls: function(refineObj) {
      refineName = this.facetEncodedUrl(refineObj.refineName);
      refineLabel = this.facetEncodedUrl(refineObj.refineLabel);

      var equalsRefineLabel = function(label) {
    	  return label === refineLabel;
      }
      
      // To construct URL parameter for facet.
      if (this.refinementTestObj != undefined && this.refinementTestObj.hasOwnProperty(refineName) && this.refinementTestObj[refineName].some(equalsRefineLabel)) {
    	  return;
      } else if (this.refinementTestObj != undefined && this.refinementTestObj.hasOwnProperty(refineName)) {
        this.refinementTestObj[refineName].push(refineLabel);
      } else if(this.refinementTestObj != undefined && !this.refinementTestObj.hasOwnProperty(refineName)) {
        this.refinementTestObj[refineName] = [];
        this.refinementTestObj[refineName].push(refineLabel);
      }
      if (this.refinementValuesArray != undefined && this.refinementValuesArray != null && this.refinementValuesArray.hasOwnProperty(refineName)) {
        this.refinementValuesArray[refineName].push(refineObj.entry);
      } else {
        this.refinementValuesArray[refineName] = [];
        this.refinementValuesArray[refineName].push(refineObj.entry);
      }
    },
    
    /**
     * The method for moving the categoty left navigation links 
     * to the visible (expanded) section
     * First calculates number of links to show, depending of height of espot
     */
    populateCategoryListLinks: function(classId, insertTitleInList) {
    	
    	let espotElement = jQuery(classId);
      let numberOfRows = Math.floor(espotElement.height() / (2.4 * espotElement.css('line-height').replace('px',''))) + 1;
      if (!insertTitleInList) {
        numberOfRows++;
      }
    	let i = 0;
    	for (i = 0; i < numberOfRows; i++) {
        let rowDiv = $('#category-list-link' + i);
        let nextElement = $('#category-list-link' + (i + 1));
        if (rowDiv.length > 0) {
          if (!((i === (numberOfRows -1)) && (nextElement.length !== 0 ))) {
            rowDiv.appendTo('#category-list-expanded-section');
          }
        }
    	}
    	
      let nextRowDiv = $('#category-list-link' + i);
      if (nextRowDiv.length > 0) {
    		 $("#categoryListToggle").show();
 	    }
    	
    	 this.configureCategoryListShowMoreLink();
    	
      },
      
      /**
       * Add onclick event to 'Show More' link 
       * on Category List widget on Top Category
       * 
       */
      configureCategoryListShowMoreLink: function() {
    	 
    	let btn = $("#categoryListToggle");
        btn.on("click", function() {
        	let btnText = $("#category-list-toggle-text");
        	let arrow = $("#arrowSelection");
            if(btnText.attr('data-toggled') !== 'true')
            {
              btnText.attr('data-toggled', 'true');
              btnText.html(messages.SEARCH_VIEW_FEWER_CATEGORIES);
              arrow.removeClass("arrow-down");
              arrow.addClass("arrow-up");
              let nextElement = $('#category-list-colapsed-section').children().find('a')[0];
              if (nextElement != undefined) {
                  setTimeout(function(){ //Sets timeout to set focus after link are shown
                    nextElement.focus();
                  }, 25);
              }
            } else {
              btnText.attr('data-toggled', 'false');
              btnText.html(messages.SEARCH_VIEW_MORE_CATEGORIES);
              arrow.removeClass("arrow-up");
              arrow.addClass("arrow-down");
            }
        });
      },
      /**
       * Hides main category title when category list is displayed and displays the alternative smaller title.
       * @returns void
       */
      switchMainCategoryTitles: function() {
        if ($('#category-name-header').length > 0) {
          let mainTitleParent = $('#category-name-header').closest('.search-results-tile');
          mainTitleParent.addClass('hidden-xl');
          mainTitleParent.next().css('margin-top', '10px');
          $('.category-title_v2').removeClass('hidden');
        }
      },
      /**
       * Add onclick event to 'Show More' link 
       * on 'Shop By Category' list for Subcategory section
       * 
       */
      configureShopByCatShowMoreButton: function() {
     	 
      	let btn = $("#categoryListToggle");
        if (btn.length > 0) {
	      	btn.on("click", function() {
		        if(btn.attr('data-toggled') !== 'true') {
		            btn.attr('data-toggled', 'true');
		            btn.val(messages.SEARCH_VIEW_FEWER_CATEGORIES);
		        } else {
		            btn.attr('data-toggled', 'false');
		            btn.val(messages.SEARCH_VIEW_MORE_CATEGORIES);
		        }
	         });
        }
      },
      

    timeout: null,
    
    /**
     * Check if first search suggestion exists and set it to
     * screen reader announcement div
     */
    setFirstSuggestionAnnouncement : function() {
    	if ($('.tt-suggestion').length > 0 && $('#announce-first-suggestion').length > 0) {
    		var firstSuggestion = $('.tt-suggestion:first').text();
    		$('#announce-first-suggestion').text(firstSuggestion);
    	}
    },
	
    /**
     * This method adds the view more link to collections category desription
     */
    showOverflowLink: function() {
    	if ($('#col_desc_view_more_chk').length == 0) {
    		// create show more links, only one time
    		$('.ellipsis-overflow').parent().prepend('<input type="checkbox" aria-hidden="true" tabindex="-1" id="col_desc_view_more_chk" class="col-descr-show-more">');
    		$('.ellipsis-overflow').parent().append('<label class="view-more-link hidden" tabindex="0" for="col_desc_view_more_chk" role="link" id="col_desc_view_more_link">'+
    				messages.COLECTION_VIEW_MORE+'</label>');
    	}
    	
    	// check whether the description contains more than 3 columns
  	    let offsetHeight = $('.ellipsis-overflow')[0].offsetHeight;
  		let scrollHeight = $('.ellipsis-overflow')[0].scrollHeight;
  		if(offsetHeight >= scrollHeight) {
  			$("#col_desc_view_more_link").addClass('hidden');
  		} else {
  			$("#col_desc_view_more_link").removeClass('hidden');
  		}
    },
    
	 /**
     * Announce first suggestion (if any) after user's inactivity 
     */
    announceFirstSuggestion: function() {	
    	if ($('#announce-first-suggestion').length > 0) {
    		$('#announce-first-suggestion').text('');
    	}
		window.clearTimeout(this.timeout);
		timeout = window.setTimeout(this.setFirstSuggestionAnnouncement, 2000);
		
    },
    /*
     * ALM 28431
     * Forcing aria attributes dynamically after page load
     * This function is also called in browse.js (init) 
     */
    forceAriaAttributes: function() {
    	if (document.getElementById('search-results')) {
            let present_view = $('.product-list').hasClass('list') ? 'list' : 'grid',
              $products = $('.product-list .product'),
              $hr = $('.product-list hr'),
              $list_icon = $('.list a'),
              $grid_icon = $('.grid a');
            
            $('.co-grid-view').attr('aria-hidden','true');
            $('.co-list-view').attr('aria-hidden','true');
    	}
    },
    
    /**
     * To show the warehouse flyout on click of warehouse in PLP page
     */
    showWarehouseFlyout: function(){
    	COSTCO.dialog.close();
    	window.wioEventBus.publish('openWarehouseSideBar');
    },
    
    /**
     * To show the delivery zip code on click of zip code in PLP page
     */
    showDeliveryZipcode: function(){
    	COSTCO.dialog.close();
    	window.sessionStorage.setItem("deliveryLocation", "true");
    }

  };

  if (typeof window.COSTCO == 'undefined') {
    window.COSTCO = {};
  }

  window.COSTCO.Search = Search;

  typeof window.COSTCO.Global == 'undefined' ?
    document.addEventListener('CostcoGlobalLoaded', Search.loaded, false) :
    Search.loaded();

  return Search;
});



// WEBPACK FOOTER //
// ./js/browse/search.js